/**
 * Formats an ISO date string into a human-readable date.
 * Example: "2026-04-04T00:00:00Z" → "Apr 04, 2026"
 */
export function formatDate(isoString: string): string {
  const date = new Date(isoString)
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  })
}

/**
 * Returns a relative time string like "3 days ago".
 */
export function relativeTime(isoString: string): string {
  const date = new Date(isoString)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))

  if (diffDays === 0) return 'today'
  if (diffDays === 1) return 'yesterday'
  if (diffDays < 7) return `${diffDays} days ago`
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`
  return `${Math.floor(diffDays / 365)} years ago`
}

/**
 * Alias for relativeTime — returns a relative date string.
 * Example: "2 days ago"
 */
export function formatRelativeDate(isoString: string): string {
  return relativeTime(isoString)
}

/**
 * Returns an ISO 8601 date string suitable for meta tags (e.g. og:published_time).
 * Example: "2026-04-04T12:00:00.000Z"
 */
export function formatDateForMeta(isoString: string): string {
  return new Date(isoString).toISOString()
}
